import { render } from "./frontPage.vue?vue&type=template&id=a2c77a56&scoped=true"
import script from "./frontPage.vue?vue&type=script&lang=js"
export * from "./frontPage.vue?vue&type=script&lang=js"

import "./frontPage.vue?vue&type=style&index=0&id=a2c77a56&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c77a56"]])

export default __exports__